// FormField molecule component
import { Input } from "../atoms";

export const FormField = ({
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  error,
  id,
  ...props
}) => {
  // Derive a stable id from the label so the <label> is associated with the
  // input (accessibility + testability via getByLabel).
  const fieldId =
    id ||
    (label ? `field-${label.replace(/\s+/g, "-").toLowerCase()}` : undefined);
  return (
    <div>
      {label && (
        <label htmlFor={fieldId} className="block text-sm font-semibold mb-2">
          {label}
        </label>
      )}
      <Input
        id={fieldId}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...props}
      />
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
};
